/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequestErrorDto,
  BookingInfoResponse,
  CalculateCancellationPenaltyResponseDto,
  ConfirmBookingRequestDto,
  ConflictErrorDto,
  CreateBookingRequestDto,
  CreateBookingResponseDto,
  CreateNewBookingRequest,
  GetBookingStatusResponseDto,
  InternalErrorDto,
  NotFoundErrorDto,
  TravelineVerifyBookingRequestDto,
  TravelineVerifyBookingResultDto,
} from '../models/index';
import {
    BadRequestErrorDtoFromJSON,
    BadRequestErrorDtoToJSON,
    BookingInfoResponseFromJSON,
    BookingInfoResponseToJSON,
    CalculateCancellationPenaltyResponseDtoFromJSON,
    CalculateCancellationPenaltyResponseDtoToJSON,
    ConfirmBookingRequestDtoFromJSON,
    ConfirmBookingRequestDtoToJSON,
    ConflictErrorDtoFromJSON,
    ConflictErrorDtoToJSON,
    CreateBookingRequestDtoFromJSON,
    CreateBookingRequestDtoToJSON,
    CreateBookingResponseDtoFromJSON,
    CreateBookingResponseDtoToJSON,
    CreateNewBookingRequestFromJSON,
    CreateNewBookingRequestToJSON,
    GetBookingStatusResponseDtoFromJSON,
    GetBookingStatusResponseDtoToJSON,
    InternalErrorDtoFromJSON,
    InternalErrorDtoToJSON,
    NotFoundErrorDtoFromJSON,
    NotFoundErrorDtoToJSON,
    TravelineVerifyBookingRequestDtoFromJSON,
    TravelineVerifyBookingRequestDtoToJSON,
    TravelineVerifyBookingResultDtoFromJSON,
    TravelineVerifyBookingResultDtoToJSON,
} from '../models/index';

export interface CalculateCancellationPenaltyRequest {
    number: string;
}

export interface CancelBookingRequest {
    id: string;
}

export interface ConfirmBookingRequest {
    bookingId: string;
    confirmBookingRequestDto: ConfirmBookingRequestDto;
}

export interface CreateBookingRequest {
    createBookingRequestDto: CreateBookingRequestDto;
}

export interface CreateNewBookingOperationRequest {
    createNewBookingRequest: CreateNewBookingRequest;
}

export interface GetBookingStatusRequest {
    number: string;
}

export interface GetBookingStatusByIdRequest {
    bookingId: string;
}

export interface VerifyBookingRequest {
    travelineVerifyBookingRequestDto: TravelineVerifyBookingRequestDto;
}

/**
 * 
 */
export class BookingApi extends runtime.BaseAPI {

    /**
     * Returns the penalty for cancellation of the booking
     * Get penalty by number of booking
     */
    async calculateCancellationPenaltyRaw(requestParameters: CalculateCancellationPenaltyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculateCancellationPenaltyResponseDto>> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling calculateCancellationPenalty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/penalty/{number}`.replace(`{${"number"}}`, encodeURIComponent(String(requestParameters['number']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculateCancellationPenaltyResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the penalty for cancellation of the booking
     * Get penalty by number of booking
     */
    async calculateCancellationPenalty(requestParameters: CalculateCancellationPenaltyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculateCancellationPenaltyResponseDto> {
        const response = await this.calculateCancellationPenaltyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a booking in the external system by booking ID
     * Cancel Booking
     */
    async cancelBookingRaw(requestParameters: CancelBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cancelBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Cancel a booking in the external system by booking ID
     * Cancel Booking
     */
    async cancelBooking(requestParameters: CancelBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.cancelBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm a booking in the external property management system (PMS) by booking ID
     * Confirm Booking In External System
     */
    async confirmBookingRaw(requestParameters: ConfirmBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookingInfoResponse>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling confirmBooking().'
            );
        }

        if (requestParameters['confirmBookingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'confirmBookingRequestDto',
                'Required parameter "confirmBookingRequestDto" was null or undefined when calling confirmBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bookings/{bookingId}/confirm`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmBookingRequestDtoToJSON(requestParameters['confirmBookingRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingInfoResponseFromJSON(jsonValue));
    }

    /**
     * Confirm a booking in the external property management system (PMS) by booking ID
     * Confirm Booking In External System
     */
    async confirmBooking(requestParameters: ConfirmBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookingInfoResponse> {
        const response = await this.confirmBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create booking
     * Create booking
     */
    async createBookingRaw(requestParameters: CreateBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBookingResponseDto>> {
        if (requestParameters['createBookingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createBookingRequestDto',
                'Required parameter "createBookingRequestDto" was null or undefined when calling createBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bookings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBookingRequestDtoToJSON(requestParameters['createBookingRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateBookingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create booking
     * Create booking
     */
    async createBooking(requestParameters: CreateBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBookingResponseDto> {
        const response = await this.createBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create booking
     * Create booking
     */
    async createNewBookingRaw(requestParameters: CreateNewBookingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookingInfoResponse>> {
        if (requestParameters['createNewBookingRequest'] == null) {
            throw new runtime.RequiredError(
                'createNewBookingRequest',
                'Required parameter "createNewBookingRequest" was null or undefined when calling createNewBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/booking/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNewBookingRequestToJSON(requestParameters['createNewBookingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingInfoResponseFromJSON(jsonValue));
    }

    /**
     * Create booking
     * Create booking
     */
    async createNewBooking(requestParameters: CreateNewBookingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookingInfoResponse> {
        const response = await this.createNewBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the booking status by number
     * Get the booking status by number
     */
    async getBookingStatusRaw(requestParameters: GetBookingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBookingStatusResponseDto>> {
        if (requestParameters['number'] == null) {
            throw new runtime.RequiredError(
                'number',
                'Required parameter "number" was null or undefined when calling getBookingStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/{number}/status`.replace(`{${"number"}}`, encodeURIComponent(String(requestParameters['number']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBookingStatusResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the booking status by number
     * Get the booking status by number
     */
    async getBookingStatus(requestParameters: GetBookingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBookingStatusResponseDto> {
        const response = await this.getBookingStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the booking status by ID
     * Get the booking status by ID
     */
    async getBookingStatusByIdRaw(requestParameters: GetBookingStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBookingStatusResponseDto>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling getBookingStatusById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bookings/id/{bookingId}/status`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBookingStatusResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the booking status by ID
     * Get the booking status by ID
     */
    async getBookingStatusById(requestParameters: GetBookingStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBookingStatusResponseDto> {
        const response = await this.getBookingStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Предоставляет информацию о возможности создания бронирования
     * Checking possibility of booking creation
     */
    async verifyBookingRaw(requestParameters: VerifyBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelineVerifyBookingResultDto>> {
        if (requestParameters['travelineVerifyBookingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'travelineVerifyBookingRequestDto',
                'Required parameter "travelineVerifyBookingRequestDto" was null or undefined when calling verifyBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bookings/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TravelineVerifyBookingRequestDtoToJSON(requestParameters['travelineVerifyBookingRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelineVerifyBookingResultDtoFromJSON(jsonValue));
    }

    /**
     * Предоставляет информацию о возможности создания бронирования
     * Checking possibility of booking creation
     */
    async verifyBooking(requestParameters: VerifyBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelineVerifyBookingResultDto> {
        const response = await this.verifyBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
